export default __webpack_public_path__ + "static/media/tag.fe1c891c.png";